import {TransactionApiDto} from "../../api/model/rest";
import {option, Option} from "ts-option";
import {PaymentMethod} from "../payment/Payment";
import moment = require("moment");

export default class Transaction {

	constructor(public readonly id: string,
		public readonly transactionId: Option<string>,
		public readonly date: moment.Moment,
		public readonly name: string,
		public readonly accountNo: Option<string>,
		public readonly branchCode: Option<string>,
		public readonly comment: Option<string>,
		public readonly paymentMethod: PaymentMethod,
		public readonly amount: number,
		public readonly reconciliationStatus: ReconciliationStatus,
		public readonly bankAccountType: BankAccountType,
		public readonly matched: boolean,
		public readonly due: number,
		public readonly fee: Option<number>,
		public readonly netAmount: Option<number>,
		public readonly url: Option<string>,
		public readonly visible: boolean) {}

	static fromJson(json: TransactionApiDto): Transaction {
		const date = json.date ? moment(json.date) : null;
		return new Transaction(json.id, option(json.transactionId), date, json.name, option(json.accountNo),
			option(json.branchCode), option(json.comment), PaymentMethod[json.paymentMethod], json.amount,
			ReconciliationStatus[json.status.reconcileStatus], BankAccountType[json.bankAccountType], json.status.matched,
			json.due, option(json.fee),
			option(json.netAmount), option(json.url), json.visible);
	}
}

export enum ReconciliationStatus {
	RECONCILED = "RECONCILED",
	UNRECONCILED = "UNRECONCILED",
	PARTIALLY_RECONCILED = "PARTIALLY_RECONCILED",
	IGNORED = "IGNORED"
}

export enum BankAccountType {
	TRUST_ACCOUNT = "Trust Account",
	WORKING_ACCOUNT = "Working Account"
}
